import { render, staticRenderFns } from "./handhome1.vue?vue&type=template&id=2bd9db18&scoped=true"
import script from "./handhome1.vue?vue&type=script&lang=js"
export * from "./handhome1.vue?vue&type=script&lang=js"
import style0 from "./handhome1.vue?vue&type=style&index=0&id=2bd9db18&prod&lang=scss"
import style1 from "./handhome1.vue?vue&type=style&index=1&id=2bd9db18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd9db18",
  null
  
)

export default component.exports